import { Link } from "react-router-dom";

const friendLinks = [
  { label: "影视资讯网", to: "/news/行业新闻" },
  { label: "电影社区", to: "/category/电影" },
  { label: "剧集专区", to: "/category/电视剧" },
  { label: "综艺频道", to: "/category/综艺" },
  { label: "影评专栏", to: "/news/影评" },
];

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影分类", to: "/category/电影" },
  { label: "电视剧分类", to: "/category/电视剧" },
  { label: "最新资讯", to: "/news/行业新闻" },
  { label: "站内搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100 mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">八戒影视</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80">
              八戒影视是一个面向影视爱好者的内容平台，聚焦最新电影、电视剧资讯推荐与影片资源分享，
              涵盖影视新闻、深度影评、剧集介绍与热门作品推荐，帮助你更快发现值得一看的影视佳作。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h2 className="text-sm font-bold text-background-50 mb-4">快速导航</h2>
            <ul className="space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-bold text-background-50 mb-4">友情链接</h2>
            <ul className="space-y-2.5">
              {friendLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/70">
            © 2026 八戒影视 · 本站内容与图片均为演示数据，仅供学习交流使用，不构成任何真实服务。
          </p>
          <p className="text-xs text-background-300/70">友情提示：理性观影，尊重版权</p>
        </div>
      </div>
    </footer>
  );
}